import React from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import SideMenu from './side-menu';
import { CHAT_WEB_COLUMN_HEIGHT_RATIO, DASHBOARD_LAYOUT_MAX_WIDTH } from './dashboard-layout-constants';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

interface ChatLayoutProps {
  children: React.ReactNode;
}

export function ChatLayout({ children }: ChatLayoutProps) {
  const { height: windowHeight } = useWindowDimensions();
  const columnHeight = windowHeight * CHAT_WEB_COLUMN_HEIGHT_RATIO;

  return (
    <View style={styles.bodyContainer}>
      <SideMenu />
      <View style={[styles.mainPanel, { height: columnHeight }]}>
        <View style={styles.childrenContainer}>{children}</View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  bodyContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'stretch',
    width: '100%',
    maxWidth: DASHBOARD_LAYOUT_MAX_WIDTH,
    marginHorizontal: 'auto',
    marginTop: theme.spacing['spacing.general.x4'],
    minHeight: 0,
    justifyContent: 'center',
  },
  mainPanel: {
    flex: 1,
    minWidth: 0,
    maxWidth: 630,
    borderWidth: 1,
    borderColor: theme.colors['surface.inverse.tertiary-neutral'],
    borderRadius: theme.borderRadii['radius.lg'],
    overflow: 'hidden',
    backgroundColor: theme.colors['surface.default'],
  },
  childrenContainer: {
    flex: 1,
    minHeight: 0,
    width: '100%',
  },
});
